module.exports = __webpack_public_path__ + "img/coaching_3.095f6d4e.png";